<div [formGroup]="zone1Form">
  <div class='container'>
    <div class="card">
      <div class="card-body">
        <h2 class="card-title btn-ouline-success-title">Zone n°1</h2>
        <div class="row">
          <div class='col-12'>
            <label class="form-label">Type de pose <span class="required">*</span></label>
            <div class="btn-group d-block" role="group">
              <ng-container *ngFor="let typePose of typePoses">
                <input type="radio" formControlName="typePoseZone1" class="btn-check btn-type-pose-options" [value]="typePose.code" [id]="typePose.code + 1"
                       (change)='onRadioClickZone1(typePose.code, "typePoseZone1")' tabindex="1">
                <label class="btn btn-outline-success btn-type-pose-options" [for]="typePose.code + 1"> {{ typePose.label }}</label>
              </ng-container>
            </div>
            <input type="hidden" formControlName="typePoseZone1" name="typePoseZone1"
                   [ngClass]="zone1Form.get('typePoseZone1').invalid && (zone1Form.get('typePoseZone1').dirty || zone1Form.get('typePoseZone1').touched) ? 'is-invalid' : ''">
            <div class="invalid-feedback">
              <div *ngIf="zone1Form.get('typePoseZone1').errors?.['required']">Le type de pose est obligatoire</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" *ngIf="zone1Form.get('typePoseZone1').value === 'TOITURE'">
      <div class="card-body">
        <h2 class="card-title">Toiture</h2>
        <div class="row">
          <div class="col-5">
              <label class="form-label" for="typeToitureZone1">Type toiture <span class="required">*</span></label>
              <select class="form-select" id="typeToitureZone1" formControlName="typeToitureZone1" tabindex="10"
                      [ngClass]="zone1Form.get('typeToitureZone1').invalid && (zone1Form.get('typeToitureZone1').dirty || zone1Form.get('typeToitureZone1').touched) ? 'is-invalid' : ''">
                <option value=""></option>
                <option *ngFor="let typeToitureZone1 of typeToitures" [ngValue]="typeToitureZone1.code"
                        [selected]="zone1Form.get('typeToitureZone1').value && typeToitureZone1.code === zone1Form.get('typeToitureZone1').value">
                  {{ typeToitureZone1.label }}
                </option>
              </select>
              <div class="invalid-feedback">
                <div *ngIf="zone1Form.get('typeToitureZone1').errors?.['required']">Le type de toiture est obligatoire</div>
              </div>
          </div>
          <div class="col-3">
            <div class="form-group form-check">
              <span class="spanCheckbox">PV Ready <span class="required">*</span></span>
              <input class="form-check-input" type="checkbox" formControlName="pvReadyZone1" tabindex="11"
                     [ngClass]="zone1Form.get('pvReadyZone1').invalid && (zone1Form.get('pvReadyZone1').dirty || zone1Form.get('pvReadyZone1').touched) ? 'is-invalid' : ''">
              <div class="invalid-feedback">
                <div *ngIf="zone1Form.get('pvReadyZone1').errors?.['required']">Cocher PV Ready</div>
              </div>
            </div>
          </div>
          <div class="col-4">
              <div class="row">
                <label for="inclinaisonZone1" class="form-label">Inclinaison <span class="required">*</span></label>
                <div class="col-10">
                  <input type="number" class="form-control" id="inclinaisonZone1" formControlName="inclinaisonZone1" placeholder="Ex : 100" tabindex="12"
                         [ngClass]="zone1Form.get('inclinaisonZone1').invalid && (zone1Form.get('inclinaisonZone1').dirty || zone1Form.get('inclinaisonZone1').touched) ? 'is-invalid' : ''">
                  <div class="invalid-feedback">
                    <div *ngIf="zone1Form.get('inclinaisonZone1').errors?.['pattern']">L'inclinaison n'est pas valide</div>
                    <div *ngIf="zone1Form.get('inclinaisonZone1').errors?.['required']">L'inclinaison est obligatoire</div>
                    <div *ngIf="zone1Form.get('inclinaisonZone1').errors?.['inclinaisonMax']">
                      L'inclinaison doit être comprise entre 0 et 3°
                    </div>

                    <div *ngIf="zone1Form.get('inclinaisonZone1').errors?.['inclinaisonMin']">
                      L'inclinaison doit être supérieure à 3°
                    </div>
                  </div>
                </div>
                <div class="col-1">
                  <span class="spanTextMiddle">°</span>
                </div>
              </div>
          </div>
        </div>
        <div class="row" *ngIf="zone1Form.get('typeToitureZone1').value === 'BETON' || zone1Form.get('typeToitureZone1').value === 'TAN_ETANCHE'">
          <div class="col-12">
            <label class="form-label">Orientation</label>
            <div class="btn-group d-block" role="group">
              <input type="radio" formControlName="orientationTerrasseZone1" class="btn-check btn-type-pose-options" value="SUD" id="orientationSudZone1" tabindex="13">
              <label class="btn btn-outline-success btn-type-pose-options" for="orientationSudZone1">SUD</label>
              <input type="radio" formControlName="orientationTerrasseZone1" class="btn-check btn-type-pose-options" value="EST_OUEST" id="orientationEstOuestZone1" tabindex="14">
              <label class="btn btn-outline-success btn-type-pose-options" for="orientationEstOuestZone1">EST/OUEST</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="zone1Form.get('typePoseZone1').value === 'OMBRIERE'">
      <div class="card-body">
        <h2 class="card-title">Ombrière</h2>
        <div class="vehicule-options">
        <img
          src="../../../../assets/images/img/pl.png"
          alt="Poids Lourd"
          class="vehicule-img"
          [class.selected]="zone1Form.get('typeVehiculeParkingZone1')?.value === 'PL'"
          (click)="selectVehicule('PL', null)"
        />
      
        <img
          src="../../../../assets/images/img/vl_place_1.png"
          alt="VL Place 1"
          class="vehicule-img"
          [class.selected]="isVLSelected('PLACE_1')"
          (click)="selectVehicule('VL', 'PLACE_1')"
        />
      
        <img
          src="../../../../assets/images/img/vl_place_2.png"
          alt="VL Place 2"
          class="vehicule-img"
          [class.selected]="isVLSelected('PLACE_2')"
          (click)="selectVehicule('VL', 'PLACE_2')"
        />
      
        <img
          src="../../../../assets/images/img/vl_portique.png"
          alt="VL Portique"
          class="vehicule-img"
          [class.selected]="isVLSelected('PORTIQUE')"
          (click)="selectVehicule('VL', 'PORTIQUE')"
        />
      
        <img
          src="../../../../assets/images/img/vl_place_1_bois.png"
          alt="VL Place 1 Bois"
          class="vehicule-img"
          [class.selected]="isVLSelected('PLACE_1_BOIS')"
          (click)="selectVehicule('VL', 'PLACE_1_BOIS')"
        />
      
        <img
          src="../../../../assets/images/img/vl_place_2_bois.png"
          alt="VL Place 2 Bois"
          class="vehicule-img"
          [class.selected]="isVLSelected('PLACE_2_BOIS')"
          (click)="selectVehicule('VL', 'PLACE_2_BOIS')"
        />
        
        <img
          src="../../../../assets/images/img/est_ouest.png"
          alt="VL Est Ouest"
          class="vehicule-img"
          [class.selected]="isVLSelected('EST_OUEST')"
          (click)="selectVehicule('VL', 'EST_OUEST')"
        />
      </div>
      <div
        class="error-message"
        *ngIf="
          zone1Form.get('typeVehiculeParkingZone1')?.invalid &&
          zone1Form.get('typeVehiculeParkingZone1')?.touched
        "
      >
        Le type de véhicule sur le parking est obligatoire
      </div>
      </div>
    </div>
    <div class="card" *ngIf="zone1Form.get('typePoseZone1').value">
      <div class="card-body">
        <div class="row">
          <div class='col-12'>
            <label for="surfaceZone1" class="form-label">Surface <span class="required">*</span></label>
            <div class="row">
              <div class="col-10">
                <input type="number" class="form-control" id="surfaceZone1" formControlName="surfaceZone1" placeholder="Ex : 45.32" tabindex="8"
                 [attr.disabled]="true"
                 [ngClass]="zone1Form.get('surfaceZone1').invalid && (zone1Form.get('surfaceZone1').dirty || zone1Form.get('surfaceZone1').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone1Form.get('surfaceZone1').errors?.['required']">La surface est obligatoire</div>
                  <div *ngIf="zone1Form.get('surfaceZone1').errors?.['pattern']">La surface n'est pas valide</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">m²</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-12'>
            <label for="puissanceChoisieZone1" class="form-label">Puissance choisie</label>
            <div class="row">
              <div class="col-10">
                <input
                  type="number"
                  class="form-control"
                  id="puissanceChoisieZone1"
                  formControlName="puissanceChoisieZone1"
                  (focus)="onPuissanceChoisieFocus($event)"
                  [ngClass]="(zone1Form.get('puissanceChoisieZone1').invalid && (zone1Form.get('puissanceChoisieZone1').dirty || zone1Form.get('puissanceChoisieZone1').touched)) || (zone1Form.errors?.['surfaceOrPowerRequired'] && zone1Form.get('typePoseZone1').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone1Form.get('puissanceChoisieZone1').errors?.['pattern']">La puissance choisie n'est pas valide</div>
                  <div *ngIf="zone1Form.errors?.['surfaceOrPowerRequired']">La surface ou la puissance choisie est obligatoire</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">kWc</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-12'>
            <label for="azimutZone1" class="form-label">{{ azimutLabel }} <span class="required">*</span></label>
            <div class="row">
              <div class="col-10">
                <input type="number" class="form-control" id="azimutZone1" formControlName="azimutZone1" placeholder="Ex : 100" tabindex="9"
                 [attr.disabled]="true"
                 [ngClass]="zone1Form.get('azimutZone1').invalid && (zone1Form.get('azimutZone1').dirty || zone1Form.get('azimutZone1').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone1Form.get('azimutZone1').errors?.['required']">L'azimut est obligatoire</div>
                  <div *ngIf="zone1Form.get('azimutZone1').errors?.['pattern']">L'azimut n'est pas valide</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">°</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
